<template>
  <div class="loading-container">
    <img class="loading-img" :src="loadingImg" alt="loading" />
  </div>
</template>

<script>
export default {
  name: "Loading",
  data() {
    return {
      loadingImg: require("@/assets/loading.gif")
    };
  }
};
</script>

<style lang="scss" scoped>
.loading-container {
  height: 100vh;
  max-height: 100vh;
  width: 100vw;
  max-width: 100vw;
  background: white;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  .loading-img {
    max-width: 100px;
    max-height: 100px;
  }
}
</style>